
define('text!templates/widgets/dataGridCells/inputCell.html',[],function () { return '<input data-bind="value: $data.val, valueUpdate: &apos;afterkeyup&apos;">';});

